(function ($) {
  $(function() {
    var $twoColumnCard = $('.two-col-card');

    if ($twoColumnCard.length) {
      
      $twoColumnCard.each(function() {
        $cardElement = $(this).find('.resource-card__content');

        $cardElement.matchHeight();
      });
    }
  });
})(jQuery);